// src/components/Login.jsx

import React, { useState } from 'react';
import { Box, Button, Container, TextField, Typography, Avatar, Link as MuiLink } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { loginStart, loginSuccess, loginFailure } from '../../redux/authSlice'; // Import actions
import { Link as RouterLink, useNavigate } from 'react-router-dom'; // Import RouterLink and useNavigate
import logo from '../../assets/logo.png'; // Adjust path based on your actual file structure

const Login = () => {
  const [formData, setFormData] = useState({ email: '', password: '' });
  const dispatch = useDispatch();
  const error = useSelector(state => state.auth.error);
  const navigate = useNavigate(); // Initialize navigate hook from react-router-dom

  const handleInputChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleLogin = () => {
    const storedData = JSON.parse(localStorage.getItem('userData'));
    if (storedData && storedData.email === formData.email && storedData.password === formData.password) {
      const fakeUser = { email: formData.email, username: storedData.username }; // Example user
      dispatch(loginStart()); // Dispatch login start action
      setTimeout(() => {
        dispatch(loginSuccess(fakeUser)); // Dispatch login success action with user data
        navigate('/'); // Redirect to home page after successful login
      }, 1000); // Simulate async login process
    } else {
      dispatch(loginFailure('Invalid credentials')); // Dispatch login failure action with error message
    }
  };

  return (
    <Container maxWidth="xs">
      <Box sx={{ mt: 4, display: 'flex', flexDirection: 'column', alignItems: 'center', border: '1px solid #ccc', borderRadius: '8px', p: 3 }}>
        <Avatar alt="Logo" src={logo} sx={{ width: 64, height: 64, mb: 2 }} />
        <Typography variant="h5" gutterBottom>
          Login
        </Typography>
        {error && (
          <Typography variant="body2" color="error" gutterBottom>
            {error}
          </Typography>
        )}
        <Box component="form" noValidate sx={{ mt: 1, width: '100%' }}>
          <TextField
            margin="normal"
            required
            fullWidth
            id="email"
            label="Email Address"
            name="email"
            autoComplete="email"
            autoFocus
            value={formData.email}
            onChange={handleInputChange}
          />
          <TextField
            margin="normal"
            required
            fullWidth
            name="password"
            label="Password"
            type="password"
            autoComplete="current-password"
            value={formData.password}
            onChange={handleInputChange}
          />
          <Button
            type="button"
            fullWidth
            variant="contained"
            color="primary"
            sx={{ mt: 3, mb: 2 }}
            onClick={handleLogin}
          >
            Login
          </Button>
          <Typography variant="body2">
            Don't have an account?{' '}
            <MuiLink component={RouterLink} to="/register">
              Register here
            </MuiLink>
          </Typography>
        </Box>
      </Box>
    </Container>
  );
};

export default Login;
